import React, { FC, useEffect, useState } from "react";
import { PromptCard } from "./promptCard";
import * as S from "./styled";

import { TestPromptDTO } from "@dasha.ai/sdk/web/rest-api/generated/testsystem";
import { useStore } from "@core/api/GlobalStoreContext";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { Divider, Loader, Message, Search } from "semantic-ui-react";
import UIManager from "@core/misc/UIManager";
import { ScrollbarStyle } from "../uikit";

export const PromptsView: FC<{}> = observer(({}) => {
  const { prompts } = useStore();
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    prompts.loadPromptsAsync().catch((e) => UIManager.notice(`Failed to load prompts: ${e}`));
  }, [prompts]);
  return (
    <>
      <S.Content id="prompts">
        <Search
          loading={prompts.loading}
          placeholder="Search prompts"
          onSearchChange={(e, { value }) => {
            setSearchValue(value ?? "");
          }}
          value={searchValue}
          results={prompts.Prompts.filter((prompt) =>
            prompt.name.toLowerCase().includes(searchValue.toLowerCase())
          ).map((prompt) => ({
            title: prompt.name,
            description: prompt.description,
            url: `/prompts/${prompt.id}`,
          }))}
          resultRenderer={(result) => <Link to={result.url}>{result.title}</Link>}
          
        />
        <div style={{ marginBottom: '16px' }}></div>
        <S.Prompts>
          {<Loader active={prompts.loading} content={"Loading prompts"}></Loader>}
          {!prompts.loading && prompts.Prompts.length === 0 && (
            <Message>Utilize our inspector tool to incorporate prompts and tests from conversations.</Message>
          )}
          {prompts.Prompts.filter((prompt) => prompt.name.toLowerCase().includes(searchValue.toLowerCase())).map(
            (prompt) => (
              <Link to={`/prompts/${prompt.id}`}>
                <PromptCard prompt={prompt} />
              </Link>
            )
          )}
        </S.Prompts>
      </S.Content>
    </>
  );
});
